import { useSelector } from 'react-redux'

export default function RoyaltyAndPrivileged() {
  const { mintRoyalty } = useSelector(state=>state.nfts)
  return (
    <div style={{ justifyContent: 'center' }}>
      {mintRoyalty ? <p>Royalty: {(mintRoyalty / 10).toFixed(1)}%</p> : null}
    </div>
  )
}
